<template>
  <b-card no-body>
    <b-card-header
      :class="{
        'd-flex' : !$isMobile()
      }"
      class="border-0 justify-content-between align-items-center">
      <h3 class="mb-0" v-if="!$isMobile()">{{ $t('transfers.list') }}</h3>
      <div
        class="d-flex"
        :class="{
            'flex-column' : $isMobile(),
            'align-items-start' : $isMobile()
          }"
      >
        <div
          :class="{
              'w-100' : $isMobile()
            }"
        >
          <span class="myspan">{{ $t('common.from') }}</span>
          <el-date-picker
            v-model="date1"
            type="date"
            size="medium"
            value-format="yyyy-MM-dd"
            class="mydate-input"
            :class="{
                'mb-2' : $isMobile(),
                'mx-3' : !$isMobile(),
              }"
            :placeholder="$t('common.select')">
          </el-date-picker>
        </div>
        <div
          :class="{
              'w-100' : $isMobile()
            }"
        >
          <span class="myspan">{{ $t('common.to') }}</span>
          <el-date-picker
            v-model="date2"
            type="date"
            size="medium"
            value-format="yyyy-MM-dd"
            class="mydate-input"
            :class="{
                'mb-2' : $isMobile(),
                'mx-3' : !$isMobile()
              }"
            :placeholder="$t('common.select')">
          </el-date-picker>
        </div>

        <el-input
          :placeholder="$t('common.search')"
          prefix-icon="el-icon-search"
          size="medium"
          class="mysearch-input"
          v-model="search">
        </el-input>
      </div>
    </b-card-header>

    <div class="single-scroll-container" ref="containerWrapper">
      <div class="table-responsive-wrapper" ref="horizontalScrollWrapper">
        <el-table class="table-responsive table"
                  header-row-class-name="thead-light"
                  :data="data"
                  v-loading="initialLoading"
                  :element-loading-text="$t('transfers.loadingData')"
                  element-loading-spinner="el-icon-loading"
                  height="100%"
                  ref="elTable"
        >
          <el-table-column :label="$t('transfers.sender')"
                           prop="card_sender"
                           min-width="180px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.recipient')"
                           prop="card_receiver"
                           min-width="180px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.amountUzs')"
                           prop="amount"
                           min-width="150px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.status')"
                           prop="status"
                           min-width="150px"
          >
            <template v-slot="{row}">
              <badge class="badge-dot mr-4" v-if="row.statusType == 'danger'" v-b-popover.hover.top="`${row.error_message}`"
                     type="">
                <i :class="`bg-${row.statusType}`"></i>
                <span class="status" :class="`text-${row.statusType}`">{{ row.status }}</span>
              </badge>

              <badge class="badge-dot mr-4" v-else type="">
                <i :class="`bg-${row.statusType}`"></i>
                <span class="status" :class="`text-${row.statusType}`">{{ row.status }}</span>
              </badge>
            </template>
          </el-table-column>
          <el-table-column :label="$t('transfers.cheque')"
                           prop="cheque"
                           min-width="150px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.datetime')"
                           prop="created_at"
                           min-width="180px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.systemCheque')"
                           prop="transfer_token"
                           min-width="180px"
          >
          </el-table-column>
          <el-table-column :label="$t('transfers.system')"
                           prop="type"
                           min-width="150px"
          >
          </el-table-column>
        </el-table>
      </div>

      <!-- No results message -->
      <div v-if="data.length === 0 && !initialLoading && !moreLoading" class="text-center empty-message">
        <i class="ni ni-folder-17 display-4 text-muted"></i>
        <p class="mt-2">{{ $t('transfers.noData') }}</p>
      </div>

      <!-- Loading spinner at bottom -->
      <div v-if="moreLoading" class="loading-more">
        <div class="spinner-container">
          <span class="spinner-border spinner-border-sm" role="status"></span>
          <span class="ml-2">{{ $t('common.loading') }}</span>
        </div>
      </div>

      <!-- New data notification -->
      <transition name="fade">
        <div v-if="showNewDataNotification" class="new-data-notification">
          <span>{{ $t('transfers.addedNew', { count: newRowsCount }) }}</span>
        </div>
      </transition>

      <!-- End of data message -->
      <div v-if="stopLoad && data.length > 0" class="text-center text-muted py-3 end-message">
        <small>Все данные загружены</small>
      </div>
    </div>
  </b-card>
</template>
<script>
import {Table, TableColumn} from 'element-ui'
import axios from 'axios'
import {throttle, debounce} from 'lodash'

export default {
  name: 'light-table',
  components: {
    'el-table': Table,
    'el-table-column': TableColumn
  },
  props: {
    tableData: {
      type: Array,
      default: function() {
        return []
      }
    },
    type: {
      type: String,
      default: ''
    }
  },
  data: function() {
    return {
      date1: '',
      date2: '',
      search: '',
      currentPage: 0,
      initialLoading: false,
      moreLoading: false,
      stopLoad: false,
      data: [],
      loadingInProgress: false,
      showNewDataNotification: false,
      newRowsCount: 0,
      notificationTimeout: null,
      lastScrollTop: 0,
      requestId: 0
    };
  },
  watch: {
    search: {
      handler: function () {
        this.debouncedReset();
      },
      immediate: false
    },
    date1: {
      handler: function () {
        this.resetAndFetchData();
      },
      immediate: false
    },
    date2: {
      handler: function () {
        this.resetAndFetchData();
      },
      immediate: false
    }
  },
  created: function () {
    this.handleTableScroll = throttle(this.checkScrollDirection, 200);
    // Wait until the user stops typing instead of firing a request per keystroke
    this.debouncedReset = debounce(this.resetAndFetchData, 400);
  },
  mounted: function () {
    this.initialLoad();
    this.setupScrollListeners();
    window.addEventListener('resize', this.adjustTableHeight);

    // Add touch events for better mobile scroll detection
    if (this.$isMobile && this.$isMobile()) {
      this.$nextTick(() => {
        const wrapper = this.$refs.horizontalScrollWrapper;
        if (wrapper) {
          // Force overflow settings directly on the DOM element
          wrapper.style.overflowX = 'auto';
          wrapper.style.webkitOverflowScrolling = 'touch';

          // For some mobile browsers that might need a hint about scrollability
          if ('ontouchstart' in window) {
            wrapper.addEventListener('touchstart', () => {
              wrapper.style.overflowX = 'auto';
            });
          }
        }
      });
    }
  },
  beforeDestroy: function () {
    this.removeScrollListeners();
    window.removeEventListener('resize', this.adjustTableHeight);
    this.debouncedReset.cancel();

    if (this.notificationTimeout) {
      clearTimeout(this.notificationTimeout);
    }
  },
  methods: {
    setupScrollListeners: function() {
      const elTable = this.$refs.elTable;
      if (elTable && elTable.$el) {
        const bodyWrapper = elTable.$el.querySelector('.el-table__body-wrapper');
        if (bodyWrapper) {
          bodyWrapper.addEventListener('scroll', this.handleTableScroll);
        }
      }
    },

    removeScrollListeners: function() {
      const elTable = this.$refs.elTable;
      if (elTable && elTable.$el) {
        const bodyWrapper = elTable.$el.querySelector('.el-table__body-wrapper');
        if (bodyWrapper) {
          bodyWrapper.removeEventListener('scroll', this.handleTableScroll);
        }
      }
    },

    resetAndFetchData: function () {
      // New filters win: responses of requests started before this point are ignored
      this.requestId++;
      this.data = [];
      this.currentPage = 0;
      this.stopLoad = false;
      this.initialLoading = false;
      this.moreLoading = false;
      this.loadingInProgress = false;
      this.initialLoad();
    },

    initialLoad: function () {
      var self = this;
      if (this.initialLoading || this.stopLoad) return;

      var requestId = this.requestId;
      this.initialLoading = true;
      this.currentPage = 1;

      axios.post('dashboard/' + this.type + '-transfers?page=' + this.currentPage, {
        data: this.search.trim(),
        fromDate: this.date1,
        toDate: this.date2
      })
        .then(function (response) {
          if (requestId !== self.requestId) return;
          if (response.data.transfers && Array.isArray(response.data.transfers)) {
            if (response.data.transfers.length === 0 || response.data.transfers.length < 25) {
              self.stopLoad = true;
            }

            self.data = response.data.transfers;
          } else {
            console.error('Invalid response format:', response.data);
            self.stopLoad = true;
          }
        })
        .catch(function (error) {
          if (requestId !== self.requestId) return;
          console.error('Error loading data:', error);
          self.stopLoad = true;
        })
        .finally(function () {
          if (requestId !== self.requestId) return;
          self.initialLoading = false;
          self.$nextTick(function() {
            self.adjustTableHeight();
            self.setupScrollListeners();
          });
        });
    },

    loadMoreData: function () {
      var self = this;
      if (this.moreLoading || this.stopLoad || this.loadingInProgress) return;

      var requestId = this.requestId;
      this.moreLoading = true;
      this.loadingInProgress = true;
      this.currentPage++;

      axios.post('dashboard/' + this.type + '-transfers?page=' + this.currentPage, {
        data: this.search.trim(),
        fromDate: this.date1,
        toDate: this.date2
      })
        .then(function (response) {
          if (requestId !== self.requestId) return;
          if (response.data.transfers && Array.isArray(response.data.transfers)) {
            if (response.data.transfers.length === 0) {
              self.stopLoad = true;
              return;
            }

            // Remember the count of new rows for notification
            self.newRowsCount = response.data.transfers.length;

            // Concatenate new data to existing data
            self.data = self.data.concat(response.data.transfers);

            // Show notification that new rows were added
            self.showNewDataNotification = true;

            // Clear any existing timeout
            if (self.notificationTimeout) {
              clearTimeout(self.notificationTimeout);
            }

            // Hide notification after 3 seconds
            self.notificationTimeout = setTimeout(() => {
              self.showNewDataNotification = false;
            }, 3000);

            if (response.data.transfers.length < 25) {
              self.stopLoad = true;
            }
          } else {
            console.error('Invalid response format:', response.data);
            self.stopLoad = true;
          }
        })
        .catch(function (error) {
          if (requestId !== self.requestId) return;
          console.error('Error loading more data:', error);
          self.stopLoad = true;
        })
        .finally(function () {
          if (requestId !== self.requestId) return;
          self.moreLoading = false;

          // Add a small delay to prevent multiple rapid requests
          setTimeout(function () {
            self.loadingInProgress = false;
          }, 300);
        });
    },

    checkScrollDirection: function (event) {
      if (this.stopLoad || this.moreLoading || this.loadingInProgress) return;

      const target = event.target;
      const scrollTop = target.scrollTop;
      const scrollHeight = target.scrollHeight;
      const clientHeight = target.clientHeight;

      // Calculate distance from bottom
      const distanceFromBottom = scrollHeight - scrollTop - clientHeight;

      // Check if we're scrolling down and near the bottom (less than 100px from bottom)
      if (scrollTop > this.lastScrollTop && distanceFromBottom < 100) {
        this.loadMoreData();
      }

      // Update the last scroll position
      this.lastScrollTop = scrollTop;
    },

    adjustTableHeight: function () {
      const container = this.$refs.containerWrapper;
      if (!container) return;

      // Calculate viewport height minus other elements
      const headerElement = document.querySelector('.b-card-header');
      const headerHeight = headerElement ? headerElement.offsetHeight : 0;
      const viewportHeight = window.innerHeight;
      const offset = 100; // Adjust this value based on your layout

      // Set a minimum height and adjust based on viewport
      const tableHeight = Math.max(400, viewportHeight - headerHeight - offset);
      container.style.height = tableHeight + 'px';

      // Force el-table to update its layout
      this.$nextTick(() => {
        if (this.$refs.elTable) {
          this.$refs.elTable.doLayout();

          // Check if we're on mobile
          if (this.$isMobile && this.$isMobile()) {
            // Make sure the min-width is set properly for scrolling
            const tableEl = this.$refs.elTable.$el;
            if (tableEl) {
              const tableBody = tableEl.querySelector('.el-table__body');
              const tableHeader = tableEl.querySelector('.el-table__header');

              // Calculate the total width needed based on column min-widths
              // Each column has a min-width of at least 150px and we have 8 columns
              const minTableWidth = Math.max(1200, window.innerWidth * 1.5);

              if (tableBody) tableBody.style.minWidth = minTableWidth + 'px';
              if (tableHeader) tableHeader.style.minWidth = minTableWidth + 'px';
            }
          }
        }
      });
    }
  }
}
</script>

<style>
.single-scroll-container {
  position: relative;
  height: calc(100vh - 200px);
  min-height: 400px;
  overflow: hidden;
}

.table-responsive-wrapper {
  width: 100%;
  height: 100%;
  overflow-x: auto !important;
  overflow-y: hidden !important;
  /* Critical for mobile horizontal scrolling */
  -webkit-overflow-scrolling: touch;
}

.single-scroll-container .el-table {
  height: 100% !important;
}

/* Make table layout support min-width columns better */
.single-scroll-container .el-table table {
  table-layout: auto !important;
  min-width: 100%;
}

/* Fix for Element UI table width on mobile */
.single-scroll-container .el-table__body,
.single-scroll-container .el-table__header {
  min-width: 1200px !important; /* Force minimum width to ensure scrolling */
}

/* Ensure only the body wrapper scrolls, not the whole table */
.single-scroll-container .el-table__header-wrapper {
  overflow: hidden;
}

.single-scroll-container .el-table__body-wrapper {
  overflow-y: scroll !important;
  overflow-x: visible !important; /* Allow horizontal scrolling to pass through */
  height: calc(100% - 40px) !important; /* Account for header height */
  scrollbar-width: thin;
  scrollbar-color: #5e72e4 #f6f9fc;
}

/* Customize scrollbar for WebKit browsers */
.table-responsive-wrapper::-webkit-scrollbar,
.single-scroll-container .el-table__body-wrapper::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.table-responsive-wrapper::-webkit-scrollbar-track,
.single-scroll-container .el-table__body-wrapper::-webkit-scrollbar-track {
  background: #f6f9fc;
  border-radius: 4px;
}

.table-responsive-wrapper::-webkit-scrollbar-thumb,
.single-scroll-container .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #5e72e4;
  border-radius: 4px;
  border: 2px solid #f6f9fc;
}

.loading-more {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.9);
  z-index: 10;
}

.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 15px;
  color: #8898aa;
  font-size: 14px;
}

.new-data-notification {
  position: fixed;
  bottom: 20px;
  right: 20px;
  background-color: #5e72e4;
  color: white;
  padding: 10px 15px;
  border-radius: 4px;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  z-index: 9999;
  transition: opacity 0.3s, transform 0.3s;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.empty-message, .end-message {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 5;
}

.empty-message {
  top: 50%;
  transform: translateY(-50%);
}

.end-message {
  bottom: 10px;
}

.myspan {
  font-size: 15px;
}

.mysearch-input {
  width: 230px;
}

.mydate-input {
  width: 150px !important;
}

.el-input.is-active .el-input__inner, .el-input__inner:focus {
  border-color: #5e72e4 !important;
}

.card .table td, .card .table th {
  padding-right: 0rem !important;
  padding-left: 1.5rem !important;
}

/* Animation for new items */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.el-table__row {
  animation: fadeIn 0.3s ease-out;
}

/* Mobile specific styles */
@media only screen and (max-width: 768px) {
  .mydate-input {
    width: 100% !important;
  }

  .mysearch-input {
    width: 100%;
  }

  .single-scroll-container {
    height: calc(100vh - 250px);
    min-height: 300px;
  }

  /* Critical fixes for horizontal scrolling on mobile */
  .table-responsive-wrapper {
    overflow-x: auto !important;
    overflow-y: hidden !important;
    -webkit-overflow-scrolling: touch;
    max-width: 100vw;
  }

  /* Horizontally scrollable table needs fixed layout */
  .el-table {
    width: auto !important;
    min-width: 100% !important;
  }

  /* Force table to be wider than viewport to enable horizontal scrolling */
  .el-table__body,
  .el-table__header {
    min-width: 1200px !important;
  }

  /* Prevent X scrolling on body wrapper to avoid double scrollbars */
  .el-table__body-wrapper {
    overflow-x: visible !important;
  }

  /* Fix table cell styling for mobile */
  .single-scroll-container .el-table .cell {
    white-space: nowrap !important;
    padding-right: 10px !important;
  }

  /* Add visual indicator for horizontal scroll */
  .single-scroll-container::after {
    content: '';
    position: absolute;
    right: 10px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%235e72e4' width='24px' height='24px'%3E%3Cpath d='M0 0h24v24H0V0z' fill='none'/%3E%3Cpath d='M15.41 16.59L10.83 12l4.58-4.59L14 6l-6 6 6 6 1.41-1.41z'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    transform: rotate(-90deg);
    opacity: 0.6;
    pointer-events: none;
    animation: fadeSwipe 2s infinite;
    z-index: 20;
  }

  @keyframes fadeSwipe {
    0% { opacity: 0.2; transform: rotate(-90deg) translateX(0); }
    50% { opacity: 0.8; transform: rotate(-90deg) translateX(10px); }
    100% { opacity: 0.2; transform: rotate(-90deg) translateX(0); }
  }

  /* Remove border-radius and drop shadows on mobile to avoid overflow issues */
  .el-table__header-wrapper,
  .el-table__body-wrapper {
    border-radius: 0 !important;
  }

  /* Override any position:sticky that might interfere with scrolling */
  .el-table__header-wrapper {
    position: relative !important;
  }
}
</style>
